import React, { useEffect, useMemo, useState } from "react";
import DataTable from "../../../../../../Common/DataTable/DataTable";
import DataTableHeader from "../../../../../../Common/DataTableHeader/DataTableHeader";
import DataTableFooter from "../../../../../../Common/DataTableFooter/DataTableFooter";
import { leaveRequestApi } from "../../../../../../api/leaveRequestApi";


const ArchivedLeaveCancellationTable = ({ refreshKey }) => {

    const [rows, setRows] = useState([]);
    const [exportRows, setExportRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const tableData = useMemo(() => rows, [rows]);

    const formatDate = (date) => {
        if (!date) return "-";
        return new Date(date).toLocaleDateString("en-US", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            timeZone: "UTC",
        });
    };

    useEffect(() => {
        let isMounted = true;

        const load = async () => {
            setLoading(true);
            setError("");

            try {
                const response =
                    await leaveRequestApi.getArchivedCancellationRequests();

                const items = Array.isArray(response?.data)
                    ? response.data
                    : [];

                if (!isMounted) return;

                const uiRows = [];
                const exportData = [];

                items.forEach((item) => {

                    uiRows.push({
                        employeeName: (
                            <span className="fw-semibold">
                                {item.EmployeeName}
                            </span>
                        ),
                        requestedOnRaw: item.CancellationRequestedDate,
                        requestedOn: formatDate(item.CancellationRequestedDate),

                        archivedOnRaw: item.ArchivedDate,
                        archivedOn: formatDate(item.ArchivedDate),

                        leaveType: (
                            <span className="badge bg-primary">
                                {item.LeaveType}
                            </span>
                        ),
                        from: formatDate(item.StartDate),
                        to: formatDate(item.EndDate),

                        totalDays: (
                            <span className="badge bg-info">
                                {item.TotalDays}
                            </span>
                        ),

                        reason: item.CancellationReason,

                        remarks: item.CancellationAdminRemarks
                            ? (
                                <span title={item.CancellationAdminRemarks}>
                                    {item.CancellationAdminRemarks.length > 40
                                        ? item.CancellationAdminRemarks.slice(0, 40) + "..."
                                        : item.CancellationAdminRemarks}
                                </span>
                            )
                            : (
                                <span className="text-muted">-</span>
                            ),

                        status: item.Archived == 1
                            ? (
                                <span className="badge bg-success">
                                    Approved
                                </span>
                            )
                            : (
                                <span className="badge bg-danger">
                                    Rejected
                                </span>
                            ),
                    });

                    exportData.push({
                        employeeName: item.EmployeeName,
                        requestedOn: formatDate(item.CancellationRequestedDate),
                        archivedOn: formatDate(item.ArchivedDate),
                        leaveType: item.LeaveType,
                        from: formatDate(item.StartDate),
                        to: formatDate(item.EndDate),
                        totalDays: item.TotalDays,
                        reason: item.CancellationReason,
                        remarks: item.CancellationAdminRemarks || "-",
                        status: item.Archived === 1 ? "Approved" : "Rejected",
                    });

                });

                setRows(uiRows);
                setExportRows(exportData);

            } catch (err) {
                if (!isMounted) return;
                setError(err?.message || "Failed to load archived cancellation requests");
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        load();
        return () => { isMounted = false; };

    }, [[refreshKey]]);



    const columns = [
        { Header: "Employee Name", accessor: "employeeName" },
        { Header: "Requested On", accessor: "requestedOn" },
        { Header: "Approved On", accessor: "archivedOn" },
        { Header: "Leave Type", accessor: "leaveType" },
        { Header: "From", accessor: "from" },
        { Header: "To", accessor: "to" },
        { Header: "Total Days", accessor: "totalDays" },
        { Header: "Cancellation Reason", accessor: "reason" },
        { Header: "Remarks", accessor: "remarks" },
        { Header: "Status", accessor: "status" },
    ];

    return (
        <>
            {/* <DataTableHeader columns={columns} data={exportRows} /> */}

            {error && <div className="alert alert-danger">{error}</div>}

            <div className="leave-table-shell leave-admin-table-shell">
                <DataTable
                    columns={columns}
                    data={tableData}
                    loading={loading}
                    reportMode={true}
                    disableSorting={true}
                    enablePagination={false}
                />
            </div>

            {/* <DataTableFooter dataT={tableData} /> */}
        </>
    );
};

export default ArchivedLeaveCancellationTable;
